<template>
  <div>
    <v-select
      hide-details="auto"
      :items="selectableSalesSource"
      class="datainput justify-content-end align-self-center"
      dense
      clearable
      outlined
      :label="$t('select_label')"
      v-model="searchText"
      @change="onSearch()"
    ></v-select>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  data() {
    return {
      searchText: null,
      selectableSalesSource: [
        {
          value: "3P",
          text: "3P",
        },
        {
          value: "IC",
          text: "IC",
        },
        {
          value: "OE",
          text: "OE",
        },
        {
          value: "IV",
          text: "IV",
        },
      ],
    };
  },
  props: {
    columnHeader: String,
    onCustomEvent: Function,
  },

  mounted() {
    if (sessionStorage.getItem("salesSource")) {
      this.searchText = sessionStorage.getItem("salesSource");
    }
    eventBus.$on("clear-filters", this.clearFilters);
  },
  methods: {
    clearFilters() {
      this.searchText = null;
      const columnHeader = this.params.columnHeader;

      if (columnHeader == "salesSource") {
        sessionStorage.removeItem("salesSource");
      }
    },
    onSearch() {
      const searchText = this.searchText;
      const columnHeader = this.params.columnHeader;
      if (
        columnHeader == "salesSource" &&
        searchText !== undefined &&
        searchText !== null &&
        searchText.trim() !== ""
      ) {
        sessionStorage.setItem("salesSource", searchText);
      } else {
        sessionStorage.removeItem("salesSource");
      }
      this.$parent.$listeners.onFilterChanged(columnHeader, searchText);
    },
  },
};
</script>
